import { useMemo } from 'react';
import { TileDataSheetBackedWithSheet } from '@common/api';
import { useDashboardContext } from '@features/dashboard/Dashboard';

export const useTileGlobalOverride = (data: TileDataSheetBackedWithSheet) => {
    const { useDashboardSort, useDashboardFilters, useDashboardTimeline } = data;
    const { rows, columns, autoRefresh } = useDashboardContext();

    const globalOverride = useMemo(
        () => ({
            rows: {
                sort: useDashboardSort ? rows.sort : undefined,
                filters: useDashboardFilters ? rows.filters : undefined,
            },
            columns: useDashboardTimeline ? columns : undefined,
            linkedTimeline: useDashboardTimeline,
            autoRefresh,
        }),
        [useDashboardSort, useDashboardFilters, useDashboardTimeline, rows, columns, autoRefresh]
    );

    return globalOverride;
};
